import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import * as fromRoot from '@app/store/app.reducer';
import * as fromCalcularion from '@app/store/my-zone/calculation/calculation.actions';
import { ProductSelectorService } from '@app/store/my-zone/product/product-selector.service';
import * as fromProduct from '@app/store/my-zone/product/product.actions';
import { StorageService } from '@inshared/shared/util-storage';
import { Store } from '@ngrx/store';
import {
    DateService,
    EnvironmentEnum,
    EnvironmentService,
    RelationDataService,
    RelationInterface,
} from 'outshared-lib';
import { Observable } from 'rxjs';

@Component({
    selector: 'ins-my-zone-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ins-my-zone [loaded]="loaded$ | async" [relation]="relation$ | async" [ezine]="ezine"> </ins-my-zone>
    `,
})
export class MyZoneContainer implements OnDestroy {
    public loaded$: Observable<boolean> = this.productSelectorService.isProductLoaded$;
    public relation$: Observable<RelationInterface> = this.relationDataService.getRelation$();

    public get ezine(): boolean {
        if (this.storage.getObject('Is.eZine')) {
            return this.dateService.nowAsString() <= this.storage.getObject('Is.eZine');
        }

        if (!this.storage.getObject('Is.eZineCheck')) {
            const ezineExpire = this.dateService.add(3, 'month');
            this.storage.putObject('Is.eZineCheck', 1, { expires: this.dateService.add(1, 'year') });
            this.storage.putObject('Is.eZine', ezineExpire, { expires: ezineExpire });

            return true;
        }

        return false;
    }

    constructor(
        private readonly store: Store<fromRoot.State>,
        private readonly dateService: DateService,
        private readonly productSelectorService: ProductSelectorService,
        private readonly relationDataService: RelationDataService,
        @Inject(StorageService) private storage,
        private environmentService: EnvironmentService
    ) {
        this.environmentService.setCurrentEnvironment(EnvironmentEnum.Netherlands);
    }

    public ngOnDestroy(): void {
        this.store.dispatch(new fromProduct.Clear());
        this.store.dispatch(new fromCalcularion.Clear());
    }
}
